var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconChange = function SvgIconChange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.861 8.954c.55 0 1.01.461 1.01 1.028v1.17a5.042 5.042 0 0 1-5.034 5.036H7.57v1.47a.919.919 0 0 1-.479.817.961.961 0 0 1-.443.106.843.843 0 0 1-.496-.142l-3.901-2.5a.906.906 0 0 1-.425-.78c0-.318.159-.602.425-.78l3.9-2.5a.93.93 0 0 1 1.436.781v1.489h5.249a3.004 3.004 0 0 0 2.996-2.996v-1.17a1.03 1.03 0 0 1 1.029-1.029zm-3.97-7.093c.3-.16.672-.142.956.035l3.901 2.5c.266.178.426.48.425.8a.931.931 0 0 1-.425.78l-3.9 2.5a.965.965 0 0 1-.941.035.922.922 0 0 1-.478-.816V6.188H7.182a3.004 3.004 0 0 0-2.996 2.996v1.17a1.03 1.03 0 0 1-2.057 0v-1.17a5.043 5.043 0 0 1 5.035-5.035h5.249V2.677c0-.337.177-.657.478-.816z",
    fill: "#FA5851",
    fillRule: "evenodd"
  })));
};

export default SvgIconChange;